import React from "react";
import logoFavicon from "../images/logos/bestjobsonline.svg";
import { Helmet } from "react-helmet";

export default function Favicon() {
  return (
    <Helmet>
      <link
        rel="apple-touch-icon"
        href={logoFavicon}
        type="image/svg+xml"
      ></link>
      <link rel="icon" href={logoFavicon} type="image/svg+xml"></link>
    </Helmet>
  );
}
